var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"height":_vm.height,"width":_vm.width,"src":_vm.spinnerUrl,"alt":"loading"}})}
var staticRenderFns = []

export { render, staticRenderFns }